import { Link } from 'react-router-dom';

export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-file-list-3-line',
      title: 'Monthly Financial Reports',
      description: 'Receive detailed monthly reports that give you a clear picture of your business finances, helping you make informed decisions for growth.'
    },
    {
      icon: 'ri-exchange-dollar-line',
      title: 'Accounts Payable & Receivable',
      description: 'We manage your invoices, payments, and collections efficiently, ensuring healthy cash flow for your El Paso business.'
    },
    {
      icon: 'ri-bank-card-line',
      title: 'Bank Reconciliation',
      description: 'Keep your books accurate with regular bank reconciliation services that catch discrepancies before they become problems.'
    },
    {
      icon: 'ri-calculator-line',
      title: 'Payroll Processing',
      description: 'Streamline your payroll with accurate, timely processing that keeps your employees happy and your business compliant.'
    },
    {
      icon: 'ri-pie-chart-line',
      title: 'Financial Analysis',
      description: 'Get insights into your business performance with comprehensive financial analysis and custom reports tailored to your needs.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Tax Preparation Support',
      description: 'Stay organized year-round with bookkeeping that makes tax season stress-free and ensures you maximize deductions.'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Comprehensive <strong>Bookkeeping Services</strong> for El Paso Businesses
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our <strong>QuickBooks bookkeeping services in El Paso</strong> are designed to save you time and give you peace of mind. We handle the numbers so you can focus on growing your business.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100"
            >
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-teal-600 text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm">
          <span className="text-gray-400 font-medium">From Our Blog:</span>
          <Link to="/blog/top-cloud-accounting-softwares" className="text-teal-600 hover:text-teal-700 underline underline-offset-2 cursor-pointer font-medium">Discover which accounting software fits your business</Link>
          <Link to="/blog/bookkeeping-mistakes-el-paso" className="text-teal-600 hover:text-teal-700 underline underline-offset-2 cursor-pointer font-medium">Avoid the top bookkeeping errors hurting local businesses</Link>
          <Link to="/compare-el-paso-tax-preparation-services" className="text-teal-600 hover:text-teal-700 underline underline-offset-2 cursor-pointer font-medium">Learn how to pick the right El Paso tax professional</Link>
        </div>
      </div>
    </section>
  );
}
